@if (addresses && addresses.size) {
  @for (address of addresses | keyvalue; track address) {
    <div>
      <gea-shop-address-tile [address]="address.value" [addressTypeId]="addressTypeId" [class.current]="address.value.id == currentAddressId"
        (click)="onSelectAddress(address.value)"
        [active]="address.value.id == currentAddressId"
        [showCrudControls]="true"
        (deleteAddress)="onDeleteAddress($event)"
        (saveAddress)="onSaveAddress($event)"
        [customer]="customer()"
      ></gea-shop-address-tile>
    </div>
  }
}

@if (addressTypeId == 2) {
  <button class="btn btn-green w-100 my-2" (click)="newAddressEvent.emit(2)">
    Neue Adresse
  </button>
}

@if (! addresses || ! addresses.size) {
  <p>Es konnten keine gespeicherten Adressen gefunden werden!</p>
}

